import { DESELECT_ALL_SNAPSHOTS, SELECT_ALL_SNAPSHOTS } from '../../../store/types/snapshots';
import { CLOSE_SNAPSHOTS_EMAIL_MODAL, OPEN_SNAPSHOTS_EMAIL_MODAL } from './types';

export const selectAll = () => ({ type: SELECT_ALL_SNAPSHOTS });
export const deselectAll = () => ({ type: DESELECT_ALL_SNAPSHOTS });

export const openEmailModal = () => ({ type: OPEN_SNAPSHOTS_EMAIL_MODAL });
export const closeEmailModal = () => ({ type: CLOSE_SNAPSHOTS_EMAIL_MODAL });
